import { Email } from "../email/InputEmail/InputEmail.types";
import {
    type ExternalEmailLookupEntity,
    type ExternalEmailLookupFormValues,
    ExternalEmailLookupItem,
} from "../externalEmailLookup/ExternalEmailLookup/ExternalEmailLookup.api.types";
import { type IEmailEntryFormValues } from "./EmailFormEntry";

/**
 * Utility function to convert EmailFormEntry format to ExternalEmailLookup format
 * for API submission compatibility
 */
export function convertEmailFormEntryToExternalEmailLookup(
    emailFormValues: IEmailEntryFormValues,
): ExternalEmailLookupFormValues {
    const emailItems: ExternalEmailLookupItem[] = [];

    // Add primary email if present
    if (emailFormValues.primaryEmail?.emailAddress) {
        emailItems.push(
            new ExternalEmailLookupItem({
                emailAddress: emailFormValues.primaryEmail.emailAddress,
                friendlyName: emailFormValues.primaryEmail.friendlyName,
            }),
        );
    }

    // Add additional emails
    emailFormValues.additionalEmails.forEach((email) => {
        if (email.emailAddress) {
            emailItems.push(
                new ExternalEmailLookupItem({
                    emailAddress: email.emailAddress,
                    friendlyName: email.friendlyName,
                }),
            );
        }
    });

    return emailItems;
}

/**
 * Utility function to convert ExternalEmailLookup format to EmailFormEntry format
 * for form initialization
 */
export function convertExternalEmailLookupToEmailFormEntry(
    externalEmails: ExternalEmailLookupEntity,
): IEmailEntryFormValues {
    const emailItems = externalEmails?.emailAddress || [];
    const [primary, ...additional] = emailItems;

    return {
        primaryEmail: primary ? ExternalEmailLookupItem.asEmail(primary) : new Email(),
        additionalEmails: (additional || []).map((item) => ExternalEmailLookupItem.asEmail(item)),
    };
}
